var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  "+_vm._s(_vm.row.account)+"\n  "),(_vm.row.accountDetails.updatedAt)?_c('div',[_c('b',[_vm._v("Last updated "+_vm._s(_vm.row.accountDetails.updatedAt))])]):_vm._e(),_vm._v(" "),(_vm.row.accountDetails.transactionUser)?_c('div',[_vm._v("\n    by "+_vm._s(_vm.row.accountDetails.transactionUser)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02eff9ba","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderTable/components/tdAccount.vue
// module id = Uccw
// module chunks = 0